export const HIDE_CONTENT_FROM_SPECIAL_USERS_AFTER_DATE = new Date('2021-12-14');
export const LINK_TO_MOBILE_APP = 'https://apps.apple.com/us/app/bravado/id1558671173?itsct=apps_box_link&itscg=30200';
export const BACK_OFFICE_LATEST_URL_LOCAL_STORAGE_KEY = 'back-office-latest-url';
export const FB_APP_ID = '526703391488301';
export const GOOGLE_VERIFICATION = '51yg69067XmlVMb-HSJTa2SmLt0G71R7keH9-sV5A_4';
export const GDPR_COOKIE_BANNER_ID = process.env.isProduction
  ? '161d3426-168b-4768-afd0-b0a779373e27'
  : '161d3426-168b-4768-afd0-b0a779373e27-test';
